import * as React from "react";
const SvgFiRrCello = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cello_svg__a)">
      <path
        fill="#062147"
        d="M23.707 1.707A.999.999 0 1 0 22.293.293l-5.779 5.779A9.3 9.3 0 0 0 10.652 4q-.132-.001-.256.005c-1.384.048-2.56.998-2.857 2.31a4.7 4.7 0 0 1-1.27 2.298 4.73 4.73 0 0 1-3.135 1.383c-1.245.056-2.345.929-2.736 2.173A8.3 8.3 0 0 0 0 14.653c0 2.218.777 4.257 2.072 5.862L.293 22.294a.999.999 0 1 0 1.414 1.414l1.78-1.78a9.3 9.3 0 0 0 5.861 2.073c.801 0 1.63-.132 2.466-.393 1.271-.396 2.17-1.566 2.188-2.847a4.71 4.71 0 0 1 1.387-3.287 4.7 4.7 0 0 1 2.286-1.27c1.343-.306 2.321-1.498 2.325-2.856a9.3 9.3 0 0 0-2.072-5.862zM18 13.362c0 .416-.325.792-.77.894a6.7 6.7 0 0 0-3.258 1.804A6.7 6.7 0 0 0 12 20.735c-.006.419-.335.823-.783.963a6.3 6.3 0 0 1-1.87.303 7.3 7.3 0 0 1-4.438-1.496l1.797-1.797a.999.999 0 1 0-1.414-1.414L3.495 19.09A7.3 7.3 0 0 1 2 14.653c0-.603.104-1.237.307-1.884.138-.438.516-.758.918-.775a6.72 6.72 0 0 0 4.46-1.967c.9-.9 1.524-2.031 1.806-3.27.094-.413.514-.737.981-.754L10.652 6c1.666 0 3.204.557 4.437 1.496l-5.797 5.797a.999.999 0 1 0 1.414 1.414l5.796-5.796A7.33 7.33 0 0 1 18 13.36M17 1.5a1.5 1.5 0 1 1 3.001.001 1.5 1.5 0 0 1-3-.001m7 4a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cello_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCello;
